import { createReducer, on } from '@ngrx/store';
import {setActiveClassId} from "../actions/teacher.actions";

export const teacherFeatureKey = 'teacher';

export interface TeacherState {
  activeClassId: number;
}

export const initialState: TeacherState = {
  activeClassId: 0
};

export const reducer = createReducer(
  initialState,
  on(setActiveClassId, (state, action) => {

    return {
      ...state,
      activeClassId: action.classId
    }

  })
);
